import { MutationTree } from 'vuex'
import { ServiceState } from './types'
import Service from '@/calendesk/models/DTO/Response/Service'

export const mutations: MutationTree<ServiceState> = {
  SET_SERVICES (state, payload: Service[]) {
    state.services = payload
  }
}
